



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VTab from '@/components/items/VTab.vue';
import VChart from '@/components/items/VChart.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import reportModule from '@/store/modules/common/report.module';
import { Tab } from '@/store/models';
import VOverallReport from '@/components/report/item/VOverallReport.vue';
import VBarItemOverall from '@/components/report/item/VBarItemOverall.vue';
import _ from 'lodash';

@Component({
  name: 'ReportChart',
  components: { VBarItemOverall, VOverallReport, VChart, VTab }
})
export default class ReportChart extends Vue {
  public selectedTab: Tab = this.tabs[0];

  get max() {
    return Math.max(...this.reportData.map(x => +x.value));
  }

  get tabs(): Tab[] {
    return [
      {
        id: 1,
        title: 'Coaching Sessions Completed',
        path: 'no.OfCoachingSessionsCompleted',
        color: 'rgb(0,167,240)'
      },
      {
        id: 2,
        title: 'Employees Coached',
        path: 'no.OfEmployeesCoached',
        color: 'rgb(244,184,2)'
      },
      {
        id: 3,
        title: '% Completion of #Actions',
        path: 'percentCompletionOfActionItems',
        color: 'rgb(0,167,80)'
      },
      {
        id: 4,
        title: 'Coaching Success Index (CSI) Score',
        path: 'coachingSuccessIndex(CSI)Score',
        color: 'rgb(192,0,1)'
      },
      {
        id: 5,
        title: 'Overall Summary',
        path: '',
        color: 'black'
      }
    ];
  }

  get reportData() {
    const reportData = [...reportModule.reportData].map(item => {
      return {
        value: item[this.selectedTab.path],
        name: `${item['coachFirstName']} ${item['coachLastName']}`,
        color: this.selectedTab.color
      };
    });
    return _.orderBy(reportData, ['value'], 'desc');
  }

  get chartData() {
    return {
      datasets: [
        {
          backgroundColor: this.selectedTab.color,
          maxBarThickness: 50,
          minBarLength: 5,
          data:
            [...reportModule.reportData].map(
              item => `${item[this.selectedTab.path]}`
            ) || []
        }
      ],
      labels: [...reportModule.reportData].map(
        item => `${item['coachFirstName']} ${item['coachLastName']}`
      ),
      plugins: [ChartDataLabels]
    };
  }

  public options = {
    plugins: {
      datalabels: {
        fontWeight: 'Bold',
        anchor: 'end',
        align: 'right',
        clamp: false,
        font: {
          family: 'Montserrat Bold',
          fontColor: '#000'
        }
      }
    },
    responsive: true,
    showLine: false,
    spanGaps: false,
    layout: {
      padding: {
        right: 100,
        top: 0,
        bottom: 0
      }
    },

    scales: {
      xAxes: [
        {
          stacked: true,
          min: 0,
          ticks: {
            beginAtZero: true,
            display: false,
            fontSize: 9
          },
          gridLines: {
            display: false
          }
        }
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            fontSize: 15,
            fontFamily: 'Montserrat Medium',
            fontColor: '#000'
          },
          gridLines: {
            display: false
          }
        }
      ]
    },
    legend: {
      display: false
    }
  };
}
